import { Button, MobileStepper } from "@material-ui/core";

const StepperMobile = ({ steps = 2, activeStep, next, prev, ...rest }) => {
  return (
    <MobileStepper
      variant="dots"
      steps={steps}
      position="static"
      activeStep={activeStep}
      style={{ minHeight: "auto", marginBottom: 12 }}
      {...rest}
      nextButton={
        <Button
          size="small"
          style={{ textTransform: "none", width: 100 }}
          color="primary"
          variant="outlined"
          onClick={next}
          disabled={activeStep===steps-1}
        >
          Siguiente
        </Button>
      }
      backButton={
        <Button
          size="small"
          style={{ textTransform: "none", width: 100 }}
          color="default"
          variant="outlined"
          onClick={prev}
          disabled={activeStep === 0}
        >
          Atras
        </Button>
      }
    />
  );
};

export default StepperMobile;
